// flatpickr
import flatpickr from 'flatpickr/dist/flatpickr.min.js';
import { Japanese } from "flatpickr/dist/l10n/ja.js"
import 'flatpickr/dist/flatpickr.min.css';

// loading
function handleContentLoaded() {
  const loadingElement = document.getElementById('js-loading');
  loadingElement.classList.add('is-active');
  window.addEventListener('load', () => {
    loadingElement.classList.add('is-loaded');
  }, false);
  setTimeout(() => {
    if (!loadingElement.classList.contains('is-loaded')) {
      loadingElement.classList.add('is-loaded');
    }
  }, 5000);
}

// easylockdown対応
const observeEasyLockdownDisplayChange = (callback) => {
  const easyLockdownContent = document.querySelector('.easylockdown-content');
  if (!easyLockdownContent || easyLockdownContent.style.display !== 'none') {
    // .easylockdown-contentが非表示でない場合、または存在しない場合にコールバックを実行
    callback();
  } else {
    // .easylockdown-contentが非表示の場合、表示を検知してからコールバックを実行
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          if (easyLockdownContent.style.display !== 'none') {
            callback();
            observer.disconnect(); // 監視を停止
          }
        }
      });
    });
    observer.observe(easyLockdownContent, { attributes: true });
  }
}

// タッチイベントの有無を検出
function detectTouchEvents() {
  if (!('ontouchstart' in window)) {
    document.body.classList.add('no-touchevents');
  } else {
    document.body.classList.remove('no-touchevents');
  }
}

// Swiper
const swiperArray = [];
function swiperSlide() {
  const breakPointTb = 989;
  const breakPointSp = 749;
  const hasAncestorWithClass = (element, className) => {
    while (element) {
      if (element.classList && element.classList.contains(className)) {
        return true;
      }
      element = element.parentElement;
    }
    return false;
  };
  const createSwiper = (elem) => {
    const id = '#' + elem.id;
    const type = elem.dataset.type;
    const autoplay = elem.dataset.autoplay;
    const speed = elem.dataset.speed;

    const nextSelecter = '.swiper-button-next';
    const prevSelecter = '.swiper-button-prev';
    const paginationSelecter = '.swiper-pagination';
    const scrollbarSelecter = '.swiper-scrollbar';

    let autoPlayObj = false;
    if (autoplay == 'true') {
      const ms = speed * 1000;
      autoPlayObj = {
        delay: ms,
      }
    }

    const option = {
      autoplay: autoPlayObj,
      a11y: false
    };

    switch (type) {
      //top-visual.liquid
      case 'topVisualImage':
        let topVisualImageAutoPlayFlag = true;
        option.loop = true;
        option.speed = 800;
        option.effect = "fade";
        option.allowTouchMove = false;
        option.simulateTouch = false;
        option.touchStartPreventDefault = false;
        option.touchMoveStopPropagation = false;
        option.observer = true;
        option.observeParents = true;
        option.on = {
          observerUpdate: () => {
            if (hasAncestorWithClass(elem, "is-covered") && topVisualImageAutoPlayFlag && autoplay == 'true') {
              elem.swiper.autoplay.stop();
              topVisualImageAutoPlayFlag = false;
            }
            if (!hasAncestorWithClass(elem, "is-covered") && !topVisualImageAutoPlayFlag && autoplay == 'true') {
              elem.swiper.autoplay.start();
              topVisualImageAutoPlayFlag = true;
            }
          }
        };
        break;
      case 'topVisualText':
        let topVisualTextAutoPlayFlag = true;
        option.loop = true;
        option.speed = 800;
        option.effect = "fade";
        option.allowTouchMove = false;
        option.simulateTouch = false;
        option.touchStartPreventDefault = false;
        option.touchMoveStopPropagation = false;
        option.observer = true;
        option.observeParents = true;
        option.on = {
          observerUpdate: () => {
            if (hasAncestorWithClass(elem, "is-covered") && topVisualTextAutoPlayFlag && autoplay == 'true') {
              elem.swiper.autoplay.stop();
              topVisualTextAutoPlayFlag = false;
            }
            if (!hasAncestorWithClass(elem, "is-covered") && !topVisualTextAutoPlayFlag && autoplay == 'true') {
              elem.swiper.autoplay.start();
              topVisualTextAutoPlayFlag = true;
            }
          }
        };
        break;
      //announcement-bar.liquid
      case 'announcement':
        option.loop = true;
        option.navigation = {
          nextEl: id + ' ' + nextSelecter,
          prevEl: id + ' ' + prevSelecter
        };
        break;
      case 'thumbVisual':
        option.slidesPerView = "auto";
        option.freeMode = true;
        option.watchSlidesProgress = true;
        break;
      case 'mainVisual':
        option.loop = true;
        option.loopedSlides = 3;
        option.slidesPerView = "auto";
        option.centeredSlides = true;
        option.navigation = {
          nextEl: id + ' ' + nextSelecter,
          prevEl: id + ' ' + prevSelecter
        };
        option.pagination = {
          el: elem.dataset.progressbarId,
          type: "progressbar"
        };
        // サムネイルのスライダーオブジェクトを取得してオプションに設定
        const mainVisualThumbSwieprArray = swiperArray.filter(object => object.el.dataset.mainSwiperId === id);
        const mainVisualThumbSwieprArrayObj = mainVisualThumbSwieprArray.length > 0 ? mainVisualThumbSwieprArray[0] : undefined;
        if (mainVisualThumbSwieprArrayObj) {
          option.thumbs = {
            swiper: mainVisualThumbSwieprArrayObj
          };
        }
        // ページ数を表示する要素を取得
        const mainVisualFraction = document.querySelector(elem.dataset.fractionId);
        if (mainVisualFraction) {
          const slides = elem.querySelectorAll(".swiper-slide");
          const slideCount = slides.length;
          mainVisualFraction.textContent = `1/${slideCount}`;
          option.on = {
            slideChange: () => {
              // メインのスライダーオブジェクトを取得
              const mainSwieprArray = swiperArray.filter(object => object.el && '#' + object.el.id === id);
              const mainSwieprArrayObj = mainSwieprArray.length > 0 ? mainSwieprArray[0] : undefined;
              if (mainSwieprArrayObj) {
                // ページ数を表示
                mainVisualFraction.textContent = `${mainSwieprArrayObj.realIndex + 1} / ${slideCount}`;
              }
            }
          }
        }
        break;
      //product-slide-collection.liquid
      case 'oneImage':
        option.slidesPerView = "auto";
        option.freeMode = true;
        option.pagination = {
          el: id + ' ' + paginationSelecter,
          type: "progressbar"
        };
        break;
      case 'twoImages':
        option.slidesPerView = "auto";
        option.freeMode = true;
        option.pagination = {
          el: id + ' ' + paginationSelecter,
          type: "progressbar"
        };
        break;
      case 'collectionThumb':
        option.slidesPerView = "auto";
        option.freeMode = true;
        option.spaceBetween = 2,
          option.watchSlidesProgress = true;
        break;
      case 'collectionContents':
        option.navigation = {
          nextEl: id + ' ' + nextSelecter,
        };
        option.on = {
          slideChange: () => {
            // コンテンツのスライダーオブジェクトを取得
            const contentsSwieprArray = swiperArray.filter(object => object.el && '#' + object.el.id === id);
            const contentsSwieprArrayObj = contentsSwieprArray.length > 0 ? contentsSwieprArray[0] : undefined;
            if (contentsSwieprArrayObj) {
              // メインのスライダーオブジェクトを取得
              const mainSwieprArray = swiperArray.filter(object => '#' + object.el.id === elem.dataset.mainSwiperId);
              const mainSwieprArrayObj = mainSwieprArray.length > 0 ? mainSwieprArray[0] : undefined;
              if (mainSwieprArrayObj) {
                mainSwieprArrayObj.slideTo(contentsSwieprArrayObj.activeIndex);
              }
            }
          }
        }
        break;
      case 'collectionMain':
        option.pagination = {
          el: elem.dataset.progressbarId,
          type: "progressbar"
        };
        // サムネイルのスライダーオブジェクトを取得してオプションに設定
        const collectionMainThumbSwieprArray = swiperArray.filter(object => object.el.dataset.mainSwiperId === id);
        const ollectionMainThumbSwieprArrayObj = collectionMainThumbSwieprArray.length > 0 ? collectionMainThumbSwieprArray[0] : undefined;
        if (ollectionMainThumbSwieprArrayObj) {
          option.thumbs = {
            swiper: ollectionMainThumbSwieprArrayObj
          };
        }
        // ページ数を表示する要素を取得
        const collectionMainFraction = document.querySelector(elem.dataset.fractionId);
        if (collectionMainFraction) {
          const slides = elem.querySelectorAll(".swiper-slide");
          const slideCount = slides.length;
          collectionMainFraction.textContent = `1/${slideCount}`;
          option.on = {
            slideChange: () => {
              // メインのスライダーオブジェクトを取得
              const mainSwieprArray = swiperArray.filter(object => object.el && '#' + object.el.id === id);
              const mainSwieprArrayObj = mainSwieprArray.length > 0 ? mainSwieprArray[0] : undefined;
              if (mainSwieprArrayObj) {
                // ページ数を表示
                collectionMainFraction.textContent = `${mainSwieprArrayObj.realIndex + 1} / ${slideCount}`;
                // コンテンツののスライダーオブジェクトを取得
                const contentsSwieprArray = swiperArray.filter(object => '#' + object.el.id === elem.dataset.contentsSwiperId);
                const contentsSwieprArrayObj = contentsSwieprArray.length > 0 ? contentsSwieprArray[0] : undefined;
                if (contentsSwieprArrayObj) {
                  contentsSwieprArrayObj.slideTo(mainSwieprArrayObj.activeIndex);
                }
              }
            }
          }
        }
        break;
      case 'thumbProduct':
        option.slidesPerView = "auto";
        option.freeMode = true;
        option.spaceBetween = 2,
          option.watchSlidesProgress = true;
        break;
      case 'mainProduct':
        option.pagination = {
          el: elem.dataset.progressbarId,
          type: "progressbar"
        };
        // サムネイルのスライダーオブジェクトを取得してオプションに設定
        const mainProductThumbSwieprArray = swiperArray.filter(object => object.el.dataset.mainSwiperId === id);
        const mainProductThumbSwieprArrayObj = mainProductThumbSwieprArray.length > 0 ? mainProductThumbSwieprArray[0] : undefined;
        if (mainProductThumbSwieprArrayObj) {
          option.thumbs = {
            swiper: mainProductThumbSwieprArrayObj
          };
        }
        // ページ数を表示する要素を取得
        const mainProductFraction = document.querySelector(elem.dataset.fractionId);
        if (mainProductFraction) {
          const slides = elem.querySelectorAll(".swiper-slide");
          const slideCount = slides.length;
          mainProductFraction.textContent = `1/${slideCount}`;
          option.on = {
            slideChange: () => {
              // メインのスライダーオブジェクトを取得
              const mainSwieprArray = swiperArray.filter(object => object.el && '#' + object.el.id === id);
              const mainSwieprArrayObj = mainSwieprArray.length > 0 ? mainSwieprArray[0] : undefined;
              if (mainSwieprArrayObj) {
                // ページ数を表示
                mainProductFraction.textContent = `${mainSwieprArrayObj.realIndex + 1} / ${slideCount}`;
              }
            }
          }
        }
        break;
      case 'journal':
        option.grid = {
          rows: 2,
        };
        option.slidesPerView = "auto";
        option.freeMode = true;
        option.pagination = {
          el: id + ' ' + paginationSelecter,
          type: "progressbar"
        };
        break;
      case 'journalCategory':
        option.slidesPerView = "auto";
        option.freeMode = true;
        option.pagination = {
          el: id + ' ' + paginationSelecter,
          type: "progressbar"
        };
        break;
      case 'about':
        option.loop = true;
        option.speed = 500;
        option.allowTouchMove = false;
        option.effect = "creative";
        option.creativeEffect = {
          prev: {
            translate: ["-100%", 0, 1],
          },
          next: {
            translate: ["0%", 0, -1],
          },
        };
        break;
      case 'pickup':
        option.loop = true;
        option.loopedSlides = 3;
        option.slidesPerView = "auto";
        option.centeredSlides = true;
        option.speed = 6000;
        option.allowTouchMove = false;
        option.on = {
          afterInit: (swiper) => {
            // 子孫要素の中から data-swiper-autoplay 属性を持つ要素を探して削除
            const targetElement = swiper.el.querySelector('#js-swiper-slide--delay');
            if (targetElement) {
              targetElement.removeAttribute('data-swiper-autoplay');
            }
          }
        };
        break;
      case 'asuno':
        option.slidesPerView = "auto";
        option.centeredSlides = true;
        option.navigation = {
          nextEl: id + ' ' + nextSelecter,
          prevEl: id + ' ' + prevSelecter
        };
        option.pagination = {
          el: id + ' ' + paginationSelecter
        };
        break;
      default:
    }
    
    if (
      type == 'topVisualImage' ||
      type == 'topVisualText' ||
      type == 'announcement' ||
      type == 'mainVisual' ||
      type == 'collectionThumb' ||
      type == 'collectionContents' ||
      type == 'collectionMain' ||
      type == 'thumbProduct' ||
      type == 'mainProduct' ||
      type == 'about' ||
      type == 'asuno'
    ) {
      const swiperObj = new Swiper(id, option);
      swiperArray.push(swiperObj);
    }
    if (
      breakPointTb >= window.innerWidth && (
        type == 'thumbVisual' ||
        type == 'oneImage' ||
        type == 'twoImages' ||
        type == 'journal' ||
        type == 'journalCategory'
      )
    ) {
      const swiperObj = new Swiper(id, option);
      swiperArray.push(swiperObj);
    }
    if (breakPointSp < window.innerWidth && type == 'pickup') {
      const swiperObj = new Swiper(id, option);
      swiperArray.push(swiperObj);
    }
  };

  // resize時のswiper削除
  if (swiperArray.length > 0) {
    swiperArray.forEach((obj) => {
      if (obj.el.querySelector('.swiper-scrollbar')) {
        obj.el.querySelector('.swiper-scrollbar').innerHTML = '';
      }
      obj.destroy();
    });
    swiperArray.splice(0, swiperArray.length);
  }

  // easylockdown対応
  const initializeSwipers = () => {
    document.querySelectorAll('.js-swiper').forEach(elem => createSwiper(elem));
  };
  observeEasyLockdownDisplayChange(initializeSwipers);
}

// Click category link on collection page
const handleCategoryLinkClick = (event) => {
  if (event.target && event.target.className === 'js-category-link') {
    event.preventDefault();
    location.href = createUrl(event.target);
  }
};
const handleCategoryLinkKeyDown = (event) => {
  if (event.target && event.target.className === 'js-category-link' && event.key === 'Enter') {
    event.preventDefault();
    location.href = createUrl(event.target);
  }
};
const createUrl = (elem) => {
  const url = new URL(window.location);
  const handle = elem.getAttribute('data-handle');
  url.pathname = '/collections/' + handle;
  return url.href;
};
function categoryLink() {
  const links = document.querySelectorAll('.js-category-link');
  links.forEach(elem => {
    document.addEventListener('click', handleCategoryLinkClick, false);
    document.addEventListener('keydown', handleCategoryLinkKeyDown, false);
  });
}

// Accordion on footer
class Accordion {
  constructor(accordionElement) {
    this.accordionElement = accordionElement;
    this.iconElement = accordionElement.querySelector(".js-accordion__trigger");
    this.iconElement.addEventListener("click", () => {
      this.toggleAccordion();
    });
  }
  toggleAccordion() {
    this.accordionElement.classList.toggle("is-active");
  }
}
function initializeAccordions() {
  const accordions = document.querySelectorAll(".js-accordion");
  accordions.forEach(accordionElement => {
    new Accordion(accordionElement);
  });
}

// product quantity sync input values
function syncInputValues() {
  let inputMock = document.querySelector('input[name="quantity-mock"]');
  let inputQuantity = document.querySelector('input[name="quantity"]');
  if (inputMock && inputQuantity) {
    inputMock.addEventListener('change', function () {
      inputQuantity.value = inputMock.value;
    });
    inputQuantity.addEventListener('change', function () {
      inputMock.value = inputQuantity.value;
    });
  }
}

// scroll
function smoothScroll() {
  document.querySelectorAll('a[href^="#"].js-smooth-scroll').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      });
    });
  });
}

// TOC
function generateTOC() {
  const toc = document.getElementById('js-article-toc');
  if (toc === null) return;

  const content = document.getElementById('js-article-edit');
  const headers = Array.from(content.querySelectorAll('h1, h2, h3, h4, h5, h6'));
  if (headers.length === 0) return;

  toc.innerHTML = '';

  const dl = document.createElement('dl');
  dl.className = 'cms-journal__article-toc-def';

  const dt = document.createElement('dt');
  dt.textContent = '目次';
  dt.className = 'cms-journal__article-toc-def-term c-font__toppan';

  dl.appendChild(dt);

  const dd = document.createElement('dd');
  dd.className = 'cms-journal__article-toc-def-desc';
  const ul = document.createElement('ul');
  ul.className = 'cms-journal__article-toc-list';

  headers.forEach((header, index) => {
    const headerType = header.nodeName.toLowerCase();
    if (!header.id) {
      header.id = 'section-' + headerType + '-' + (index + 1);
    }
    const link = document.createElement('a');
    link.href = '#' + header.id;
    link.textContent = header.textContent;
    link.className = 'cms-journal__article-toc-link';

    const span = document.createElement('span');
    span.className = 'cms-journal__article-toc-link-icon';
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttributeNS(null, 'width', '6');
    svg.setAttributeNS(null, 'height', '6');
    svg.setAttributeNS(null, 'viewBox', '0 0 6 6');
    svg.setAttributeNS(null, 'fill', 'none');
    const circle1 = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    circle1.setAttributeNS(null, 'cx', '3.05');
    circle1.setAttributeNS(null, 'cy', '4.453');
    circle1.setAttributeNS(null, 'r', '1.1');
    circle1.setAttributeNS(null, 'fill', '#747369');
    circle1.setAttributeNS(null, 'transform', 'rotate(90 3.05 4.453)');
    const circle2 = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    circle2.setAttributeNS(null, 'cx', '4.85');
    circle2.setAttributeNS(null, 'cy', '1.843');
    circle2.setAttributeNS(null, 'r', '.95');
    circle2.setAttributeNS(null, 'fill', '#747369');
    circle2.setAttributeNS(null, 'transform', 'rotate(90 4.85 1.843)');
    const circle3 = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    circle3.setAttributeNS(null, 'cx', '1.15');
    circle3.setAttributeNS(null, 'cy', '1.843');
    circle3.setAttributeNS(null, 'r', '.95');
    circle3.setAttributeNS(null, 'fill', '#747369');
    circle3.setAttributeNS(null, 'transform', 'rotate(90 1.15 1.843)');
    svg.appendChild(circle1);
    svg.appendChild(circle2);
    svg.appendChild(circle3);
    span.appendChild(svg);
    link.appendChild(span);
    link.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector(e.currentTarget.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      });
    });
    const listItem = document.createElement('li');
    listItem.appendChild(link);
    listItem.className = 'cms-journal__article-toc-list-item';
    ul.appendChild(listItem);
  });

  dd.appendChild(ul);
  dl.appendChild(dd);
  toc.appendChild(dl);
}

// tab
function initializeTabs() {
  const activeClass = 'is-active';
  const tabButtons = document.querySelectorAll('.js-tab-button');
  const tabPanels = document.querySelectorAll('.js-tab-panel');
  const urlParams = new URLSearchParams(window.location.search);
  const tabIdFromUrl = urlParams.get('tab');

  function activateTab(id, position) {
    const currentHeight = document.querySelector(`.js-tab-panel.${activeClass}`)?.offsetHeight || 0;
    const currentScrollPos = window.scrollY;

    tabButtons.forEach(el => {
      el.classList.remove(activeClass);
    });
    tabPanels.forEach(el => {
      el.classList.remove(activeClass);
    });

    document.querySelectorAll(`[data-select-tab-button-id="${id}"]`).forEach(el => {
      el.classList.add(activeClass);
    });
    const newActivePanel = document.querySelector(`[data-select-panel-id="${id}"]`);
    newActivePanel.classList.add(activeClass);

    // 新しいアクティブなタブパネルの高さを取得し、高さの差分を計算
    const newHeight = newActivePanel.offsetHeight;
    const heightDiff = newHeight - currentHeight;

    // 下のタブボタンからのアクションの場合は常にスクロール位置を調整
    if (position === 'bottom') {
      window.scrollTo({ top: currentScrollPos + heightDiff });
    }
  }

  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const position = button.getAttribute('data-tab-position');
      activateTab(button.getAttribute('data-select-tab-button-id'), position);
    });
  });

  if (tabIdFromUrl) {
    activateTab(tabIdFromUrl, 'top');
  }
}

// qaリンク
function initQaLinks() {
  // クリックイベントリスナーを外側のspanに設定
  document.querySelectorAll('.js-qa-link').forEach(function (card) {
    card.addEventListener('click', function (event) {
      // クリックされた要素がaタグではない場合、data-hrefのURLに遷移
      if (!event.target.closest('a')) {
        var href = this.dataset.href;
        if (href) {
          window.location.href = href;
        }
      }
    });
  });
}

// noshi button copy
const checkboxChange = () => {
  const checkboxes = document.querySelectorAll('.js-noshi-valid-editable-check');
  checkboxes.forEach((checkbox) => {
    checkbox.checked = true;
    const event = new Event('change');
    checkbox.dispatchEvent(event);
  });
}
const createAndAppendCopyButton = (originButton) => {
  const replacedText = originButton.innerText.replace('のし', '熨斗');
  const className = 'c-button button button--primary';

  // のしの変更検知のためのカスタムイベントの定義
  const propertiesChangeEvent = new CustomEvent('propertiesChange', {
    detail: { button: originButton }
  });

  const copyButton = document.createElement('button');
  copyButton.innerText = replacedText;
  copyButton.className = className;
  copyButton.addEventListener('click', function () {
    originButton.click();
    // カスタムイベントを発火
    document.dispatchEvent(propertiesChangeEvent);
  });

  // copyButtonを追加する場所を指定して追加する
  const copyButtonContainer = document.querySelector('.js-copy-app-noshi-button-container[data-line-index="' + originButton.dataset.lineIndex + '"][data-product-id="' + originButton.dataset.productId + '"][data-variant-id="' + originButton.dataset.variantId + '"]');
  if (copyButtonContainer) {
    copyButtonContainer.appendChild(copyButton);
    const cartNoshiTableItem = copyButtonContainer.closest('.js-cart-noshi-table__item');
    if (cartNoshiTableItem) {
      cartNoshiTableItem.classList.add('is-visible');
    }
  }

  // 関連する要素のis-invalidクラスを削除する
  const relatedElements = document.querySelectorAll('.js-noshi-display-element');
  relatedElements.forEach((element) => element.classList.remove('is-invalid'));

  return copyButton;
}
function copyNoshiButton() {
  const originButtons = document.querySelectorAll('button.app-noshi-button');

  originButtons.forEach((originButton) => {
    let copyButton;

    // 既にNoshifyの処理が実行されている場合は、copyButtonを作成する
    if (window.getComputedStyle(originButton).display === 'block') {
      copyButton = createAndAppendCopyButton(originButton);
    }

    // originButtonを監視する
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          if (originButton.style.display === 'block') {
            if (!copyButton) {
              copyButton = createAndAppendCopyButton(originButton);
            }
          }
        }

        // originButtonのテキスト変更を検知する
        if (mutation.type === 'childList') {
          // originButtonのテキストを置換し、'編集'が含まれているかチェックする
          const replacedText = originButton.innerText.replace('のし', '熨斗');
          const containsEdit = replacedText.includes('編集');
          const className = containsEdit ? 'c-button button button--secondary' : 'c-button button button--primary';

          if (copyButton) {
            copyButton.innerText = replacedText;
            copyButton.className = className;
            // 熨斗が編集可能な場合は、チェックボックスをチェックする
            if (containsEdit) {
              checkboxChange();
            }
          }
        }
      });
    });

    observer.observe(originButton, { attributes: true, childList: true });
  });
}

// cart gift display
function toggleDisplayBasedOnCheckbox() {
  const checkboxes = document.querySelectorAll('.js-cart-gift-display-check');
  checkboxes.forEach((checkbox) => {
    const targetId = checkbox.getAttribute('data-display-target-id');
    const targetElement = document.getElementById(targetId);
    targetElement.style.display = checkbox.checked ? 'block' : 'none';
    checkbox.addEventListener('change', (event) => {
      const isChecked = event.target.checked;
      targetElement.style.display = isChecked ? 'block' : 'none';
    });
  });
}

//top header transparency
function observeHeaderTransparency() {
  const initObserveHeaderTransparency = () => {
    const header = document.querySelector(".js-header");
    if (!header) return;

    const topVisual = document.querySelector("#js-top-visual");
    if (!topVisual) return;

    const watchTarget = topVisual.querySelector(".js-watch-target");

    const callback = (entries) => {
      // 監視対象のエレメントがビューポートの領域を完全に出たかどうかを判定
      if (entries[0].intersectionRatio <= 0) {
        if (watchTarget.getBoundingClientRect().top >= window.innerHeight) {
          header.classList.remove("is-not-transparent");
          topVisual.classList.remove("is-covered");
        } else {
          header.classList.add("is-not-transparent");
          topVisual.classList.add("is-covered");
        }
      } else {
        header.classList.remove("is-not-transparent");
        topVisual.classList.remove("is-covered");
      }
    };

    const options = {
      root: null, // ビューポートを基準にする
      rootMargin: '0px',
      threshold: 0 // ターゲットエレメントの交差した部分の割合
    };
    const observer = new IntersectionObserver(callback, options);

    // 監視対象のエレメントを監視開始
    observer.observe(watchTarget);
  }

  // easylockdown対応
  observeEasyLockdownDisplayChange(initObserveHeaderTransparency);
}

// Top Visual リンククリック処理（Android Chrome対応）
function initTopVisualLinks() {
  const initLinks = () => {
    const topVisualLinks = document.querySelectorAll('.js-top-visual-link[href]:not([href="#"]):not([href^="javascript:"])');
    
    topVisualLinks.forEach(link => {
      let touchStartTime = 0;
      let touchStartX = 0;
      let touchStartY = 0;
      let touchMoved = false;
      let longPressTimer = null;

      // 長押しを検知してコンテキストメニューを防ぐ
      link.addEventListener('touchstart', (e) => {
        touchStartTime = Date.now();
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchMoved = false;
        
        // 700ms以上長押しした場合はコンテキストメニューを防ぐ
        longPressTimer = setTimeout(() => {
          e.preventDefault();
        }, 700);
      }, { passive: false });

      link.addEventListener('touchmove', (e) => {
        if (longPressTimer) {
          clearTimeout(longPressTimer);
          longPressTimer = null;
        }
        
        const touchEndX = e.touches[0].clientX;
        const touchEndY = e.touches[0].clientY;
        const deltaX = Math.abs(touchEndX - touchStartX);
        const deltaY = Math.abs(touchEndY - touchStartY);
        
        // 10px以上移動した場合はスワイプと判断
        if (deltaX > 10 || deltaY > 10) {
          touchMoved = true;
        }
      }, { passive: true });

      link.addEventListener('touchend', (e) => {
        if (longPressTimer) {
          clearTimeout(longPressTimer);
          longPressTimer = null;
        }
        
        const touchDuration = Date.now() - touchStartTime;
        
        // タッチが移動しておらず、700ms未満のタップの場合のみリンクを実行
        // （700ms以上長押しした場合は、touchstartでpreventDefault()が呼ばれているため、リンクは実行しない）
        if (!touchMoved && touchDuration < 700 && link.href && link.href !== '#' && !link.href.startsWith('javascript:')) {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = link.href;
        }
      }, { passive: false });

      link.addEventListener('touchcancel', () => {
        if (longPressTimer) {
          clearTimeout(longPressTimer);
          longPressTimer = null;
        }
      }, { passive: true });
    });
  };

  observeEasyLockdownDisplayChange(initLinks);
}

// クーポンコピー
function setupCouponCodeCopy() {
  document.querySelectorAll('.js-customer__coupon-item-copy').forEach((button) => {
    button.addEventListener('click', () => {
      const couponItem = button.closest('.js-customer__coupon-item');
      const couponCode = couponItem.querySelector('.js-customer__coupon-item-code').textContent;

      navigator.clipboard.writeText(couponCode).then(() => {
        alert('クーポンコードがコピーされました: ' + couponCode);
      }).catch((err) => {
        alert('コピーに失敗しました: ' + err);
      });
    });
  });
}

function initInputData() {
  // easylockdown対応
  const initFlatpickr = () => {
    flatpickr('.js-input-date', {
      locale: Japanese,
      disableMobile: true
    });
  };
  observeEasyLockdownDisplayChange(initFlatpickr);
}

function initChangeBirthday() {
  const birthdayInput = document.getElementById('js-birthday');
  if (!birthdayInput) return;

  // Flatpickrのインスタンスを取得
  const initFlatpickr = () => {
    const fp = flatpickr(birthdayInput, {
      locale: Japanese,
      disableMobile: true
    });
    return fp;
  };
  const fetchBirthdayData = () => {
    // Fetch APIを使ってデータを取得
    fetch(`${window.shopUrl}/apps/coupon/mypage/birthday`)
      .then(response => response.json())
      .then(data => {
        const birthday = data.data.birthday;
        const fp = initFlatpickr();
        fp.setDate(birthday, true);
      })
      .catch(error => console.error('Error fetching birthday data:', error));
  }
  observeEasyLockdownDisplayChange(fetchBirthdayData);
}

// 誕生日更新用リンクを追加
function initAddBirthdayLink() {

  const addBirthdayLink = (formActions) => {
    const newDiv = document.createElement('div');
    newDiv.className = 'cf-reset-password';
    const newLink = document.createElement('a');
    newLink.href = '/pages/birthday';
    newLink.textContent = '誕生日の再設定';
    newDiv.appendChild(newLink);
    formActions.appendChild(newDiv);
  }

  const targetNode = document.body;
  const config = {
    childList: true,
    subtree: true
  };
  const callback = function (mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE && node.matches('.cf-form-inner')) {
            const formActions = node.querySelector('.cf-form-actions');
            if (formActions) {
              // .cf-form-actions が見つかった場合、リンクを追加する
              addBirthdayLink(formActions);
            }
          }
        });
      }
    }
  };

  // MutationObserverのインスタンスを作成
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}

// HASHUKA パララックス効果
function initParallax() {
  // easylockdown対応
  const initializeParallax = () => {
    // 関数のプロパティとして変数を定義
    if (!initParallax.initialized) {
      initParallax.initialized = false;
      initParallax.scrollHandler = null;
      initParallax.ticking = false;
      initParallax.speed = 1.5; // 背景のスクロール速度（コンテンツの1.5倍）
    }

    const parallaxSection = document.querySelector('#js-hashuka-parallax');
    const parallaxBg = document.querySelector('#js-hashuka-parallax-bg');
    const parallaxContent = document.querySelector('#js-hashuka-parallax-content');

    if (!parallaxSection || !parallaxBg || !parallaxContent) return;

    const updateParallax = () => {
      const rect = parallaxSection.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const sectionHeight = parallaxSection.offsetHeight;
      const contentHeight = parallaxContent.offsetHeight;

      // セクションがビューポート内にある場合のみパララックス効果を適用
      if (rect.bottom >= 0 && rect.top <= windowHeight) {
        // セクションがビューポートの上端に達した時点（rect.top = 0）を基準にする
        if (rect.top >= 0) {
          // セクションがまだビューポートの上端に達していない場合、背景を初期位置に保つ
          parallaxBg.style.transform = 'translateY(0px)';
        } else {
          // セクションがビューポートの上端を超えた場合、パララックス効果を開始
          // セクションがビューポートから完全に消えるまでの距離 = sectionHeight
          // セクションが上にスクロールされた距離 = -rect.top
          // 進捗率 = -rect.top / sectionHeight (0から1まで)
          const progress = Math.min(-rect.top / sectionHeight, 1);

          // 背景の高さ
          const bgHeight = parallaxBg.offsetHeight;
          // 背景が移動する最大距離 = コンテンツの高さ - 背景の高さ
          // セクションが完全に消える時、背景の下端とコンテンツの下端が揃うようにする
          const maxTranslateY = contentHeight - bgHeight;
          // 進捗率に応じて背景を移動（1.5倍の速度で動く）
          const translateY = maxTranslateY * progress;

          parallaxBg.style.transform = `translateY(${translateY}px)`;
        }
      } else {
        // セクションがビューポート外にある場合は、背景を初期位置にリセット
        parallaxBg.style.transform = 'translateY(0px)';
      }

      parallaxBg.style.display = 'block';

      initParallax.ticking = false;
    };

    // 背景の高さを動的に計算
    // - 背景の高さ = コンテンツの高さ × パララックス速度
    const updateBgHeight = () => {
      const contentHeight = parallaxContent.offsetHeight;
      const bgHeight = contentHeight * initParallax.speed;
      parallaxBg.style.height = `${bgHeight}px`;
      // 背景の高さが更新されたら、パララックス効果も更新
      updateParallax();
    };

    // updateBgHeightを外部から呼び出せるようにする
    initParallax.updateBgHeight = updateBgHeight;

    // 背景の高さを設定
    updateBgHeight();

    const requestTick = () => {
      if (!initParallax.ticking) {
        window.requestAnimationFrame(updateParallax);
        initParallax.ticking = true;
      }
    };

    // スクロールイベントは一度だけ設定
    if (!initParallax.initialized) {
      initParallax.scrollHandler = requestTick;
      window.addEventListener('scroll', initParallax.scrollHandler, { passive: true });
      initParallax.initialized = true;
    }
  };

  observeEasyLockdownDisplayChange(initializeParallax);
}

// HASHUKA Accordion
class AccordionV2 {
  constructor(accordionElement) {
    this.accordionElement = accordionElement;
    this.buttonElement = accordionElement.querySelector(".js-accordion-v2__trigger");
    this.contentElement = accordionElement.querySelector(".js-accordion-v2__contents");
    this.isOpen = this.accordionElement.classList.contains("is-active");

    this.buttonElement.addEventListener("click", () => {
      this.toggleAccordion();
    });

    // 初期状態で is-active が付いている場合に開いた状態にする
    if (this.isOpen) {
      this.contentElement.style.maxHeight = this.contentElement.scrollHeight + "px";
    }
  }

  toggleAccordion() {
    this.isOpen = !this.isOpen;
    this.accordionElement.classList.toggle("is-active", this.isOpen);
    if (this.isOpen) {
      this.contentElement.style.maxHeight = this.contentElement.scrollHeight + "px";
    } else {
      this.contentElement.style.maxHeight = null;
    }

    // アコーディオンの開閉後にパララックス背景更新用のカスタムイベントを発火
    // アニメーション完了を待つため、transitionendイベントをリッスン
    let eventFired = false;
    const fireEvent = () => {
      if (eventFired) return;
      eventFired = true;
      const event = new CustomEvent('hashuka:accordion:toggled', {
        detail: {
          accordion: this.accordionElement,
          isOpen: this.isOpen
        }
      });
      document.dispatchEvent(event);
    };

    const handleTransitionEnd = () => {
      fireEvent();
      this.contentElement.removeEventListener('transitionend', handleTransitionEnd);
    };

    // transitionendイベントをリッスン（アニメーション完了を待つ）
    this.contentElement.addEventListener('transitionend', handleTransitionEnd, { once: true });
    
    // フォールバック: transitionendが発火しない場合に備えて、少し遅延させる
    setTimeout(() => {
      fireEvent();
    }, 300);
  }
}
function initializeAccordionsV2() {
  const accordions = document.querySelectorAll(".js-accordion-v2");
  accordions.forEach(accordionElement => {
    new AccordionV2(accordionElement);
  });

  // アコーディオンの開閉イベントをリッスンして、パララックスの背景高さを再計算
  document.addEventListener('hashuka:accordion:toggled', () => {
    // アコーディオンのアニメーション完了後に背景高さを再計算
    if (initParallax.updateBgHeight) {
      // 少し遅延させて、高さの計算が確実に行われるようにする
      setTimeout(() => {
        initParallax.updateBgHeight();
      }, 50);
    }
  });
}

// HASHUKA 文字分割
function initSplitChars() {
  const splitElements = document.querySelectorAll('.js-fade-split-chars');
  if (splitElements.length === 0) return;

  splitElements.forEach(element => {
    // 既に処理済みの場合はスキップ
    if (element.dataset.charsSplit === 'true') return;

    let charIndex = 0;
    const delayStep = 0.05; // 1文字あたりの遅延時間（秒）

    // 要素内のすべてのノードを処理
    const processNode = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        // テキストノードの場合、一文字ずつ分割
        const text = node.textContent;
        const fragment = document.createDocumentFragment();

        for (let i = 0; i < text.length; i++) {
          const char = text[i];
          // 空白文字はスキップ
          if (char.trim() === '') {
            continue;
          }
          // 文字をspanで囲む
          const span = document.createElement('span');
          span.textContent = char;
          span.classList.add('c-hashuka__fade--sequence-item');
          span.style.setProperty('--delay', `${charIndex * delayStep}s`);
          fragment.appendChild(span);
          charIndex++;
        }

        // 元のテキストノードを置き換え
        node.parentNode.replaceChild(fragment, node);
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        // 要素ノード（<br>など）の場合、子ノードを再帰的に処理
        const childNodes = Array.from(node.childNodes);
        childNodes.forEach(child => processNode(child));
      }
    };

    // すべての子ノードを処理
    const childNodes = Array.from(element.childNodes);
    childNodes.forEach(child => processNode(child));

    // 処理完了フラグを設定（クラス名とデータ属性の両方）
    element.dataset.charsSplit = 'true';
    element.classList.add('is-chars-split');
  });
}

// HASHUKA フェードイン処理
function fadeInContents() {
  const contents = document.querySelectorAll('.js-fade-in');
  if (contents.length === 0) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 文字分割が必要な要素の場合、文字分割が完了しているか確認
        if (entry.target.classList.contains('js-fade-split-chars')) {
          // 文字分割が完了していない場合はスキップ（次回のIntersectionObserverのコールバックで再チェック）
          if (!entry.target.classList.contains('is-chars-split')) {
            return;
          }
        }
        entry.target.classList.add('is-visible');
        // 一度表示された要素は監視を解除してメモリリークを防ぐ
        observer.unobserve(entry.target);
      }
    });
  }, {
    // 要素がビューポートに入る少し前から監視を開始（よりスムーズなアニメーション）
    rootMargin: '0px 0px -10% 0px',
    // 要素の10%が表示されたら発火
    threshold: 0.1
  });

  contents.forEach(content => {
    observer.observe(content);
  });
}



/* ---------------------------------------------------------------------
DOMContentLoaded
--------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  handleContentLoaded();
  detectTouchEvents();
  swiperSlide();
  categoryLink();
  initializeAccordions();
  syncInputValues();
  smoothScroll();
  generateTOC();
  initializeTabs();
  initQaLinks();
  copyNoshiButton();
  toggleDisplayBasedOnCheckbox();
  observeHeaderTransparency();
  initTopVisualLinks();
  setupCouponCodeCopy();
  initInputData();
  initChangeBirthday();
  initAddBirthdayLink();
  initParallax();
  initializeAccordionsV2();
  initSplitChars();
  fadeInContents();
}, false);

/* ---------------------------------------------------------------------
shopify:section:load
--------------------------------------------------------------------- */
document.addEventListener('shopify:section:load', () => {
  handleContentLoaded();
  detectTouchEvents();
  swiperSlide();
  categoryLink();
  initializeAccordions();
  syncInputValues();
  smoothScroll();
  generateTOC();
  initializeTabs();
  initQaLinks();
  copyNoshiButton();
  toggleDisplayBasedOnCheckbox();
  observeHeaderTransparency();
  initTopVisualLinks();
  setupCouponCodeCopy();
  initInputData();
  initChangeBirthday();
  initAddBirthdayLink();
  initParallax();
  initializeAccordionsV2();
  initSplitChars();
  fadeInContents();
}, false);

/* ---------------------------------------------------------------------
resize
--------------------------------------------------------------------- */

let currentWidth = window.innerWidth;
let resizeTimer = false;

// passive
const isPassiveSupport = () => {
  if (typeof window === 'object' && typeof window.addEventListener === 'function' && Object.defineProperty) {
    let passive = false;
    const options = Object.defineProperty({}, 'passive', {
      get() {
        passive = true;
        return passive;
      }
    });
    window.addEventListener('test', null, options);
    return passive;
  }
}

window.addEventListener('resize', () => {
  if (currentWidth == window.innerWidth) return;
  if (resizeTimer) {
    clearTimeout(resizeTimer);
  }
  resizeTimer = setTimeout(() => {
    detectTouchEvents();
    swiperSlide();
    initParallax();
    currentWidth = window.innerWidth;
  }, 200);
}, isPassiveSupport() ? { passive: true } : false);

/* ---------------------------------------------------------------------
fetch  product-slide-recommend.liquid
--------------------------------------------------------------------- */
document.addEventListener('fetchData', () => {
  swiperSlide();
}, false);

